const TemplateOrderLanding = () =>
  import(/* webpackChunkName: "template-order" */ '@/pages/template/index.vue')
const TemplateOrderWrapper = () =>
  import(
    /* webpackChunkName: "template-order" */ '@/pages/template/_type/index.vue'
  )

export default {
  path: 'template',
  meta: { label: 'template' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'TemplateOrder',
      path: '',
      meta: { label: 'templateOrder' },
      component: TemplateOrderLanding,
      props: true
    },
    {
      name: 'TemplateOrderOperation',
      path: ':type/',
      meta: { label: 'templateOrder' },
      component: TemplateOrderWrapper,
      props: true
    }
  ]
}
